<div class="flxClmn">
    <div class="page-title-container flxClmn-center" style="z-index: 45;">
        <div class="page-title-inner-container flxRow">
            <span class="page-title">URL Hunting</span>
			<more-info-c></more-info-c>
        </div>
        <div class="page-subtitle-container">
            <span class="page-subtitle">
                Find who clicked scanned links, with location, browser and device details
            </span>
        </div>
    </div>

    <div class="page-inner-content-holder no-scroll flxClmn bs-enabled">
        <!--query-->
        <ng-template #querySection>
            <div class="flex-row align-items-center" (clickOutside)="showQueryModal = false;" style="align-items: flex-end;">
                <div class="flex-row f-1-0 hvr-shadow" style="border: solid 1px var(--ui-border-strong); border-radius: var(--ui-radius-sm); overflow: visible; position: relative; min-width: 460px; height: 32px;"
                     [ngStyle]="{'border-color' : isQueryError ? 'red' : 'var(--ui-border-strong)'}">
                    <div class="flex-row hSpace05" style="align-items: center; padding: 10px; border-right: solid 1px var(--ui-border-strong); cursor: pointer; border-radius: var(--ui-radius-sm) 0 0 var(--ui-radius-sm);"
                         (click)="showQueryModal = !showQueryModal"
                         [ngStyle]="{'background' : showQueryModal ? '#f7f7f7' : 'white'}">
                        <svg xmlns="http://www.w3.org/2000/svg" class="svg-icon" style="width: 22px; height: 22px; vertical-align: middle; fill: currentColor; overflow: hidden;" viewBox="0 0 1024 1024" version="1.1"><path d="M881.4 250.9H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h739.9c23.9 0 43.5 19.6 43.5 43.5s-19.6 43.5-43.5 43.5zM272.1 454H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h130.6c23.9 0 43.5 19.6 43.5 43.5S296 454 272.1 454zM272.1 657.1H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h130.6c23.9 0 43.5 19.6 43.5 43.5s-19.6 43.5-43.5 43.5zM853.8 847.5L715.3 709c-16.9-16.9-16.9-44.6 0-61.5s44.6-16.9 61.5 0L915.3 786c16.9 16.9 16.9 44.6 0 61.5s-44.6 16.9-61.5 0zM467.9 860.2H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h326.4c23.9 0 43.5 19.6 43.5 43.5 0.1 23.9-19.5 43.5-43.5 43.5z"/><path d="M619.4 290.5C493.3 290.5 391 392.8 391 519s102.3 228.5 228.5 228.5S847.9 645.2 847.9 519 745.6 290.5 619.4 290.5z m0 388.4c-88.3 0-159.9-71.6-159.9-159.9 0-88.3 71.6-159.9 159.9-159.9s160 71.5 160 159.9c0 88.3-71.6 159.9-160 159.9z"/></svg>
                        <i class="far fa-chevron-down" style="font-size: smaller;"></i>
                    </div>

                    <div class="flex-row gap-2 f-1-0" style="align-items: center; padding: 0 10px; cursor: pointer;"
                         (click)="showQueryModal = !showQueryModal">
                        <a class="diamond-indent" style="font-weight: bold; height: auto; position: relative; padding-left: 12px; text-transform: capitalize;"
                           *ngFor="let query of queryDisplay"
						   [attr.title]="query.tooltip">
                            {{query.title}}
                        </a>
                    </div>


                    <!--query modal-->
                    <div style="position: absolute; bottom: -3px; transform: translateY(100%); line-height: 15px; left: 0; background: white; border: solid 1px var(--ui-border); border-radius: var(--ui-radius-md); box-shadow: var(--ui-shadow-lg); min-width: 537px;"
                         *ngIf="showQueryModal">
                        <div class="flex-column gap-3" style="padding: 20px;">
                            <div class="flex-row gap-3" style="align-items: center;">
                                <label class="radio-container" style="display: block; width: fit-content; height: 18px; margin: 0; padding: 0; transform: scale(0.85); margin-top: 4px;">
                                    <input type="radio" name="byLastUrlQuery" [value]="queryTypes.lastUrls"
                                           [(ngModel)]="queryType"
                                           [checked]="queryType === queryTypes.lastUrls"
                                           (change)="queryValidationErrors = [];">
                                    <span class="checkmark"></span>
                                </label>
                                <div class="flex-row gap-4 f-1-0" style="align-items: center; padding-left: 15px; position: relative;"
                                     [ngStyle]="queryType !== queryTypes.lastUrls ? {'opacity' : '0.5', 'cursor' : 'pointer'} : {'opacity' : '1' , 'cursor' : 'default'}"
                                     (click)="queryType = queryTypes.lastUrls">
                                    <span style="font-weight: bold; flex-basis: 100px;">Last URL Clicks</span>
                                </div>
                            </div>

                            <hr class="my-1"/>

                            <div class="flex-row gap-3" style="align-items: flex-start;">
                                <label class="radio-container" style="display: block; width: fit-content; height: 30px; margin: 0; padding: 0; transform: scale(0.85); margin-top: 4px;">
                                    <input type="radio" name="byUrlQuery" [value]="queryTypes.url"
                                           [(ngModel)]="queryType"
                                           [checked]="queryType === queryTypes.url"
                                           (change)="queryValidationErrors = [];">
                                    <span class="checkmark"></span>
                                </label>
                                <div class="flex-row gap-4 f-1-0" style="align-items: center; padding-left: 15px; position: relative;"
                                     [ngStyle]="queryType !== queryTypes.url ? {'opacity' : '0.5', 'cursor' : 'pointer'} : {'opacity' : '1' , 'cursor' : 'default'}"
                                     (click)="queryType = queryTypes.url">
                                    <span style="font-weight: bold; flex-basis: 73px;">URL:</span>
                                    <input type="text" style="margin: 0; flex: 1 0; max-width: 280px; height: 27px;"
                                           placeholder="Exact URL"
										   (keydown) = "removeQueryError('url');"
                                           (keydown.enter) = "applyUrlTrackingQuery();"
                                           [ngClass]="{'validation-error' : queryValidationErrors?.includes('url')}"
                                           [(ngModel)]="query.url">
                                    <span style="position: absolute; bottom: -1px; right: 20%; transform: translateY(15px); font-size: 12px; color: red;"
                                          *ngIf="queryValidationErrors?.includes('url') && !query.url">
                                        required field
                                    </span>
                                    <span style="position: absolute; bottom: -1px; right: 20%; transform: translateY(15px); font-size: 12px; color: red;"
                                          *ngIf="queryValidationErrors?.includes('url') && query.url">
                                        Please enter a valid URL
                                    </span>
                                </div>
                            </div>

                            <div class="flex-row gap-3" style="align-items: flex-start;">
                                <label class="radio-container" style="display: block; width: fit-content; height: 30px; margin: 0; padding: 0; transform: scale(0.85); margin-top: 4px;">
                                    <input type="radio" name="byDomainQuery" [value]="queryTypes.domain"
                                           [(ngModel)]="queryType"
                                           [checked]="queryType === queryTypes.domain"
                                           (change)="queryValidationErrors = [];">
                                    <span class="checkmark"></span>
                                </label>
                                <div class="flex-column gap-3" style="padding-left: 15px; flex: 1 0;"
                                     [ngStyle]="queryType !== queryTypes.domain ? {'opacity' : '0.5', 'cursor' : 'pointer'} : {'opacity' : '1' , 'cursor' : 'default'}">
                                    <div class="flex-row gap-4" style="align-items: center; position: relative;" (click)="queryType = queryTypes.domain">
                                        <span style="font-weight: bold; flex-basis: 73px;">Domain:</span>
                                        <input type="text" style="margin: 0; flex: 1 0; max-width: 280px; height: 27px;"
                                               placeholder="Exact domain"
											   (keydown) = "removeQueryError('domain');"
                                               (keydown.enter) = "applyUrlTrackingQuery();"
                                               [ngClass]="{'validation-error' : queryValidationErrors?.includes('domain')}"
                                               [(ngModel)]="query.domain">
                                        <span style="position: absolute; bottom: -1px; right: 20%; transform: translateY(15px); font-size: 12px; color: red;"
                                              *ngIf="queryValidationErrors?.includes('domain') && !query.domain">
                                            required field
                                        </span>
                                        <span style="position: absolute; bottom: -1px; right: 20%; transform: translateY(15px); font-size: 12px; color: red;"
                                              *ngIf="queryValidationErrors?.includes('domain') && query.domain">
                                            Please enter a valid domain
                                        </span>
                                    </div>
                                    <div class="flex-row gap-4" style="align-items: center;" (click)="queryType = queryTypes.domain">
                                        <span style="font-weight: bold; flex-basis: 73px;">Partial URL:</span>
                                        <input type="text" style="margin: 0; flex: 1 0; max-width: 280px; height: 27px;"
                                               placeholder="Parts of the URL (optional)"
											   (keydown.enter) = "applyUrlTrackingQuery();"
                                               [ngClass]="{'validation-error' : queryValidationErrors?.includes('partialUrl')}"
                                               [(ngModel)]="query.partialUrl">
                                    </div>
                                </div>
                            </div>

                            <div class="flex-row gap-3" style="align-items: flex-start;">
                                <label class="radio-container" style="display: block; width: fit-content; height: 30px; margin: 0; padding: 0; transform: scale(0.85); margin-top: 4px;">
                                    <input type="radio" name="byDateRangeQuery" [value]="queryTypes.dateRange"
                                           [(ngModel)]="queryType"
                                           [checked]="queryType === queryTypes.dateRange"
                                           (change)="queryValidationErrors = [];">
                                    <span class="checkmark"></span>
                                </label>
                                <div class="flex-row gap-4 align-items-center" style="padding-left: 15px; flex: 1 0;"
                                     [ngStyle]="queryType !== queryTypes.dateRange ? {'opacity': '0.5', 'cursor': 'pointer'} : {'opacity': '1', 'cursor': 'default'}"
                                     (click)="queryType = queryTypes.dateRange">
                                    <span style="font-weight: bold;">Date Range:</span>
                                    <app-dropdown-c style="width: 150px; height: 27px;"
                                                    [text]="queryPeriod.display"
                                                    (click)="queryType = queryTypes.dateRange; $event.stopPropagation()">
                                        <li *ngFor="let period of queryPeriods"
                                            (click)="queryPeriod = period">
                                            {{period.display}}
                                        </li>
                                    </app-dropdown-c>
                                </div>
                            </div>

                            <br/>
                            <span>Optional:</span>

                            <div class="flex-column gap-3" style="padding-left: 30px; flex: 1 0;"
                                 [ngStyle]="queryType === queryTypes.lastUrls ? {'opacity' : '0.5', 'pointer-events' : 'none'} : {'opacity' : '1' , 'pointer-events' : ''}">
                                <div class="flex-row gap-4" style="align-items: center; position: relative;">
                                    <span style="font-weight: bold; flex-basis: 73px;">Sender:</span>
                                    <input type="text" style="margin: 0; flex: 1 0; max-width: 280px; height: 27px;"
										   (keydown.enter) = "applyUrlTrackingQuery();"
                                           placeholder="Sender's email/domain (exact or partial)"
                                           [(ngModel)]="query.sender">
                                </div>
                                <div class="flex-row gap-4" style="align-items: center; position: relative;">
                                    <span style="font-weight: bold; flex-basis: 73px;">Mailbox:</span>
                                    <input type="text" style="margin: 0; flex: 1 0; max-width: 280px; height: 27px;"
										   (keydown.enter) = "applyUrlTrackingQuery();"
                                           placeholder="Recipient's email address (exact or partial)"
                                           [(ngModel)]="query.mailbox">
                                </div>
                                <div class="flex-row gap-4" style="align-items: center; position: relative;">
                                    <span style="font-weight: bold; flex-basis: 73px;">Subject:</span>
                                    <input type="text" style="margin: 0; flex: 1 0; max-width: 280px; height: 27px;"
                                           placeholder="Email's subject (exact or partial)"
										   (keydown.enter) = "applyUrlTrackingQuery();"
                                           [(ngModel)]="query.subject">
                                </div>
                                <div class="flex-row gap-4" style="align-items: center; position: relative;">
                                    <span style="font-weight: bold; flex-basis: 73px;">Message ID:</span>
                                    <input type="text" style="margin: 0; flex: 1 0; max-width: 280px; height: 27px;"
                                           placeholder="Message ID (exact or partial)"
										   (keydown.enter) = "applyUrlTrackingQuery();"
                                           [(ngModel)]="query.messageId">
                                </div>
                            </div>

                            <btn-c style="align-self: flex-end; height: 32px;"
                                 id="getQueryEmailsBtnInner"
                                 [loading]="getUrlTrackingInProcess"
                                 (action)="applyUrlTrackingQuery()">
                                Get
                            </btn-c>
                        </div>
                    </div>
                </div>

                <btn-c class="connected-to-left" style="align-self: flex-end; height: 32px; margin-left: -6px; z-index: 3;"
                     id="getQueryEmailsBtn"
                     [loading]="getUrlTrackingInProcess"
                     (action)="applyUrlTrackingQuery()">
                    Get
                </btn-c>
            </div>
        </ng-template>

        <trustifi-table-c *ngIf="isUrlTrackingEnabled"
                class="trustifi-table" style="flex: 1 0; z-index: 5;"
                [list]="urlInfoList"
                [headers]="[
                    {text: 'Click Time', sortKey: 'created', width: '150px'},
                    {text: 'URL', sortKey: 'long_url'},
                    {text: 'Mailbox', sortKey: 'mailbox'},
                    {text: 'Device'},
                    {text: 'IP Address', sortKey: 'device.ip', width: '120px'},
                    {text: 'Subject', sortKey: 'subject'},
                    {text: 'Sender', sortKey: 'sender'},
                ]"
                [cellsPrototype]="[
                    {textKey: 'created', textType: 'dateAndTime'},
                    {html: 'urlCell'},
                    {textKey: 'mailbox', tooltip: true},
                    {html: 'deviceCell'},
                    {textKey: 'device.ip'},
                    {textKey: 'subject', tooltip: true},
                    {textKey: 'sender', tooltip: true},
                ]"
                [cellActions] = "{
					enable: true,
					selectItemActionCb:	selectAction,
					initActionsFunction: showUrlActions
				}"
				[bulkActions]="{
					enable: true,
					selectBulkActionCb:	selectBulkAction,
					initBulkActionsFunction: showUrlBulkActions
				}"
                (searchFunction)="searchUrlClickIncident($event.searchTerm, $event.activeFilters)"
                [scopeInstances]="[{copyToClipboard: copyToClipboard, openLocation: openLocation}]"
                [options]="{
                    loadingTableFlag: getUrlTrackingInProcess,
                    exportToCsvFunction: exportToCsv,
                    itemsNameSingular: 'event',
                    defaultSortKey: '-created',
                }"
        >

			<ng-template #customCells let-item let-cellId="cellId">
				<!--device cells-->
				<div *ngIf="cellId === 'deviceCell'">
					<span tooltip="{{item.device.agent && item.device.agent.browser ? item.device.agent.browser.name + ' (' + item.device.agent.browser.version + '), ' + item.device.agent.os.name + ' (' + item.device.agent.os.version + ')' : (item.device.agent.raw.ua || 'N/A')}}">
                    <span *ngIf="item.device.agent && item.device.agent.browser" tooltip="{{item.device.agent.raw.ua}}">
                        {{item.device.agent.browser.name + ' (' + item.device.agent.browser.version + '), ' + item.device.agent.os.name + ' (' + item.device.agent.os.version + ')'}}
                    </span>
                    <span *ngIf="item.device.agent && item.device.agent.raw && !item.device.agent.browser">{{item.device.agent.raw.ua || 'N/A'}}</span>
					</span>
					<div>
						<span *ngIf="item.device.location && item.device.location">{{item.device.location.country}}{{item.device.location.city ? (', ' + item.device.location.city) : ''}}</span>
						<img style="cursor: pointer;" *ngIf="item.device.location && item.device.location.ll" (click)="openLocation(item.device.location.ll)" tooltip="Open in Google Maps" class="googleMaps" src="data:image/png;base64,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" alt=""/>
					</div>
				</div>
				<!--message id cells-->
				<div *ngIf="cellId === 'urlCell'">
					<div class="flex-row gap-2 align-items-center">
						<span class="ellipsis f-1-0" tooltip="{{item.long_url}}">{{item.long_url}}</span>
						<i class="far fa-copy copy-link ps-1" tooltip="Copy URL" (click)="copyToClipboard(item.long_url); $event.stopPropagation();"></i>
					</div>
				</div>
			</ng-template>
            <!---->
            <div tableButtons>
                <div class="flex-row">
					<ng-container *ngTemplateOutlet="querySection">
					</ng-container>
                </div>
            </div>
        </trustifi-table-c>



        <div *ngIf="!isUrlTrackingEnabled" [ngClass]="{'flex-column centralize f-1-0' : getTrackingEnabledInfoInProcess}">
            <!--"Feature not enabled" screen-->
            <div *ngIf="!getTrackingEnabledInfoInProcess" class="flex-column mt-5 align-items-center gap-3" style="max-width: 1200px; margin: auto;">
                <h2 class="opacity-50 fw-normal">URL Hunting is disabled</h2>
                <span>To use the URL Hunting tool, you need to enable the URL click tracking feature by clicking below</span>
                <span class="fw-500">Enabling URL click tracking is recommended for security teams and admins to see if users are clicking on dangerous links and investigate potential security&nbsp;breaches</span>
                <hr class="w-100">
                <btn-c class="m-auto" (action)="updateUrlHunting();">Enable URL Hunting</btn-c>
            </div>

            <!--Loader-->
			<loader *ngIf="getTrackingEnabledInfoInProcess" height="100" width="100" style="opacity: 0.8;"></loader>
        </div>
    </div>


    <!--email content popup-->
    <popup-c *ngIf="displayEmailPopup?.show"
           head="Email Details" size="medium"
           (closeCb)="displayEmailPopup = null;">
        <div class="flxClmn vSpace1 f-1-0" style="overflow: auto;">
            <span><b>Mailbox:</b> {{displayEmailPopup.mailbox}}</span>
            <span><b>Subject:</b> {{displayEmailPopup.subject}}</span>
            <span><b>Message ID:</b> {{displayEmailPopup.messageId}}</span>
            <div class="content-popup-container flxClmn centralize f-1-0" *ngIf="displayEmailPopup.inProcess">
				<loader height="100" width="100" style="opacity: 0.8;"></loader>
            </div>
            <div *ngIf="displayEmailPopup.content"
                 class="content-popup-container f-1-0" style="word-break: break-word; min-height: min(250px,30vh);"
                 [innerHTML]="displayEmailPopup.content">
            </div>
        </div>
    </popup-c>

	<preview-link-c
		*ngIf="openPreviewLinkPopup?.show"
		(cancelCb)="previewLink(false)"
		[url]="openPreviewLinkPopup.url">
	</preview-link-c>

</div>
